import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Confetti from "react-confetti";

/** Above MUI Modal (1300) and snackbar (1400) — portaled to document.body. */
const CONFETTI_Z_INDEX = 1600;

/**
 * Victory confetti for sliding play. Portaled to body so it paints over the victory modal.
 * Remount on each {@link burstKey} so every completed puzzle gets a fresh shower.
 */
export default function SlidingPlayConfetti({ active, burstKey }) {
    const [viewport, setViewport] = useState(() => ({
        width: window.innerWidth,
        height: window.innerHeight,
    }));

    useEffect(() => {
        const onResize = () => {
            setViewport({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    if (!active || typeof document === "undefined") {
        return null;
    }

    return createPortal(
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                pointerEvents: "none",
                zIndex: CONFETTI_Z_INDEX,
            }}
        >
            <Confetti
                key={burstKey}
                width={viewport.width}
                height={viewport.height}
                recycle
                numberOfPieces={200}
                style={{ pointerEvents: "none" }}
            />
        </Box>,
        document.body,
    );
}
